import { render } from "./AuthorizationPhone.vue?vue&type=template&id=0c2e536a"
import script from "./AuthorizationPhone.vue?vue&type=script&lang=js"
export * from "./AuthorizationPhone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__